if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__nav--prev')?.addEventListener('click', () => this.navigateMedia(-1));
        this.querySelector('.product-media-modal__nav--next')?.addEventListener('click', () => this.navigateMedia(1));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.openedBy = opener;
        this.querySelectorAll('[role="document"] img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
        this.showActiveMedia();

        const mediaId = opener.getAttribute('data-media-id');
        const activeImg = this.querySelector(`[role="document"] [data-media-id="${mediaId}"]`);
        const img = activeImg?.tagName === 'IMG' ? activeImg : activeImg?.querySelector('img');

        if (img && !img.complete) {
          img.addEventListener('load', () => super.show(opener), { once: true });
          img.addEventListener('error', () => super.show(opener), { once: true });
        } else {
          super.show(opener);
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[role="document"] [data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateNavVisibility();
      }

      navigateMedia(direction) {
        const items = Array.from(this.querySelectorAll('[role="document"] [data-media-id]'));
        if (items.length <= 1) return;
        const activeIndex = items.findIndex((el) => el.classList.contains('active'));
        if (activeIndex === -1) return;
        const nextIndex = (activeIndex + direction + items.length) % items.length;
        items[activeIndex].classList.remove('active');
        items[nextIndex].classList.add('active');
        this.updateNavVisibility();
      }

      updateNavVisibility() {
        const items = this.querySelectorAll('[role="document"] [data-media-id]');
        const show = items.length > 1;
        this.querySelector('.product-media-modal__nav--prev')?.style.setProperty('display', show ? '' : 'none');
        this.querySelector('.product-media-modal__nav--next')?.style.setProperty('display', show ? '' : 'none');
      }
    }
  );
}
